import { fetch } from '../fetchWrapper/fetch';
import { PRICE_SCHEME_HEADER } from '../constants';
import { API_URL } from '../constants';

export const triggerPriceSchemeExport = async (priceSchemeId?: string, menuId?: string) => {
  const queryString = menuId ? `?menu_id=${menuId}` : '';

  const response = await fetch(
    `${API_URL}/pricing/schemes/export${queryString}`,

    {
      method: 'POST',
      headers: {
        ...(priceSchemeId ? { [PRICE_SCHEME_HEADER]: priceSchemeId } : {}),
      },
    },
  );
  const data = await response.json();

  return data.trace_id;
};
